module.exports = __webpack_public_path__ + "img/80_pourcent.38fe1021.png";